import type { AxiosRequestConfig } from "axios";
import { LogSeverity, LogSource } from "@/constants/errorConstants";
import type SearchGridSchema from "@/interfaces/SearchGridSchema";
import Logger from "@/utils/Logger";
import { apiGet } from "./api";

type SearchHistoryApiRow = Omit<SearchGridSchema, "scmIDNum"> & {
	scmHdrId?: number;
	scmIDNum?: number;
};

interface SearchHistoryResponse {
	responseObject: SearchHistoryApiRow[];
}

const getSearchHistory = async (
	scmIDNum: number,
	itemNumber: number,
	config?: AxiosRequestConfig,
): Promise<SearchGridSchema[]> => {
	const scmHdrId = scmIDNum;
	const response = await apiGet<SearchHistoryResponse>(
		`/search/history/${scmHdrId}/${itemNumber}`,
		config,
	);
	if (!response) {
		Logger.error(
			`No response from getSearchHistory API for SCM ID: ${scmIDNum}, Item Number: ${itemNumber}`,
			null,
			["SearchHistoryApi"],
		);
		return [];
	}

	Logger.info(JSON.stringify(response.responseObject), ["SearchHistoryApi"]);
	return (response.responseObject ?? []).map((row) => ({
		...row,
		scmIDNum: row.scmHdrId ?? row.scmIDNum,
	}));
};

export const SearchHistoryApi = {
	getSearchHistory,
};
